import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {RestService} from "../immerdrin/rest.service.interface";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {LoggerService} from "../../shared/logger.service";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {AuthService} from "../../shared/auth.service";
import {InsertEditMitDialogs} from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http"; import {FormsModule} from "@angular/forms";

const PATH_FILE = 'app/protected/kernrecht/kernrecht.insertEdit.component.ts';

@Component({
    selector: 'oase-kernrecht-insertEdit.dialog',
    templateUrl: './kernrecht.insertEdit.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class KernrechtInsertEditComponent extends InsertEditMitDialogs {

    constructor(
        public dialogRef: MatDialogRef<KernrechtInsertEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
        public _logger: LoggerService) {

        super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);

    }

    specificInitHandling(aktuell: any) {
        aktuell.tempSprachSchluessel = aktuell.sprachschluessel != null ? aktuell.sprachschluessel.replace(/^recht./, '') : "";
    }

    specificPreSaveHandling(aktuell: any) {
        aktuell.sprachschluessel = "recht."+aktuell.tempSprachSchluessel;
    }
}
